import React from "react";
import { RISK_STYLES, NONE_STYLE } from "@/lib/constants";

export function RiskBadge({ risk, size = "md", testId }) {
  const s = RISK_STYLES[risk] || NONE_STYLE;
  const Icon = s.Icon;
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad}`}
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} strokeWidth={2.5} />
      {s.label}
    </span>
  );
}

export function StatusPill({ status, testId }) {
  const bg = { bg: "#F1F5F9", text: "#475569", border: "#E2E8F0" };
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold mono"
      style={{ background: bg.bg, color: bg.text, borderColor: bg.border }}
    >
      {status}
    </span>
  );
}
